import React from "react";
import PropTypes from "prop-types";
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
} from "@material-ui/core";

const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: false,
    label: "ID Pedido",
  },
  {
    id: "fullname",
    numeric: false,
    disablePadding: false,
    label: "Nombre Cliente",
  },
  { id: "address", numeric: false, disablePadding: false, label: "Dirección" },
  { id: "total", numeric: true, disablePadding: false, label: "Total" },
  {
    id: "date",
    numeric: false,
    disablePadding: false,
    label: "Pedido realizado",
  },
];

export default function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort, actionIcon } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "center"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        {actionIcon && <TableCell>Acción</TableCell>}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
